// extracted by mini-css-extract-plugin
export var titleContainer = "Light-module--title-container--1Jb2C";
export var imgContainer = "Light-module--img-container--2goUu";
export var contentColumnContainer = "Light-module--content-column-container--fW8E1";
export var contentColumn = "Light-module--content-column--ymOJM";
export var introductionColumn = "Light-module--introduction-column--28u1u";
export var tipContainer = "Light-module--tip-container--2Tj4k";
export var tipImageContainer = "Light-module--tip-image-container--qA8wS";
export var tipText = "Light-module--tip-text--2gBqZ";